<script lang="ts" setup>
import { computed } from 'vue';
import IoInputWrapper from '@/components/form/InputWrapper.vue';

const modelValue = defineModel<boolean>();

withDefaults(defineProps<{
  label?: string;
}>(), {
  label: undefined,
});

const value = computed<boolean>({
  get() {
    return !!modelValue.value;
  },
  set(val: unknown) {
    modelValue.value = !!val;
  },
});
</script>

<template>
  <IoInputWrapper
    :label="label"
    class="io-checkbox__wrapper"
  >
    <template v-slot:inLabel="{ inputId }">
      <input
        :id="inputId"
        class="base-input__checkbox"
        type="checkbox"
        v-model="value"
      />
    </template>
  </IoInputWrapper>
</template>

<style lang="scss">
.io-checkbox__wrapper label {
  line-height: 1.4;
  margin: .35em 0 .5em !important;
  display: flex;
  font-size: 14px;
  font-weight: 400;
  vertical-align: middle;
  align-items: center;

  input {
    border: 1px solid #8c8f94;
    border-radius: 4px;
    background: #fff;
    color: #50575e;
    clear: none;
    cursor: pointer;
    display: inline-block;
    line-height: 0;
    height: 1rem;
    margin: -.25rem 0 0 0;
    outline: 0;
    padding: 0 !important;
    text-align: center;
    vertical-align: middle;
    width: 1rem;
    min-width: 1rem;
    -webkit-appearance: none;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, .1);
    transition: .05s border-color ease-in-out;

    + span {
      display: inline-block;
      padding-left: 10px;
    }
  }
}
</style>
